<template>
    <form action="/" @submit.prevent="() => {}">
        <transition name="fade" appear>
            <div

                :class="{
                'coffee-card-controls': true,
                'coffee-card-controls--loading': this.isLoading
            }"
            >
                <div class="coffee-card-controls__variants">
                    <div class="coffee-card-controls__weight">
                        <template v-if="weightItems.length">
                            <div class="variants-group variants-group--weight">
                                <div
                                    class="variants-group__item"
                                    v-for="weightItem in weightItems"
                                    :key="weightItem.KEY"
                                >
                                    <label class="coffee-variant">
                                        <input
                                            name="weight"
                                            :value="weightItem.VALUE"
                                            v-model="selectedWeight"
                                            type="radio"
                                            class="coffee-variant__input"
                                        >
                                        <span class="coffee-card__variant-label coffee-variant__label">
                                        {{ weightItem.PRINT_VALUE }}
                                    </span>
                                    </label>
                                </div>
                            </div>
                        </template>
                        <template v-if="quantityItems.length">
                            <div class="variants-group variants-group--weight">
                                <div
                                    class="variants-group__item"
                                    v-for="item in quantityItems"
                                    :key="item.KEY"
                                >
                                    <label class="coffee-variant">
                                        <input
                                            name="weight"
                                            :value="item.VALUE"
                                            v-model="selectedQuantity"
                                            type="radio"
                                            class="coffee-variant__input"
                                        >
                                        <span class="coffee-card__variant-label coffee-variant__label">
                                        {{ `${item.PRINT_VALUE} шт` }}
                                    </span>
                                    </label>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="coffee-card-controls__roasting">
                        <div class="variants-group variants-group--roasting">
                            <div
                                class="variants-group__item"
                                v-for="roastDegreeItem in roastDegreeItems"
                                :key="roastDegreeItem.KEY"
                            >
                                <label
                                    :class="`coffee-variant coffee-variant--roasting ${roastDegreeItem.VALUE !== 'эспрессо' || 'coffee-variant--roasting-reach'}`"
                                >
                                    <input
                                        name="roasting"
                                        :value="roastDegreeItem.VALUE"
                                        v-model="selectedRoast"
                                        type="radio"
                                        class="coffee-variant__input"
                                    >
                                    <span class="coffee-card__variant-label coffee-variant__label"
                                          data-toggle="tooltip"
                                          data-html="true"
                                          :title="`<div class='tooltip-body tooltip-body--coffee'>
                                                <span class='d-sm-inline-flex d-none mr-1'>
                                                    ${roastDegreeItem.VALUE === 'эспрессо' ? `<img src='${ICONS_PATH}icon-coffee-bean-full.svg' />` : ''}
                                                    <img src='${ICONS_PATH}icon-coffee-bean-full.svg' />
                                                    —
                                                </span>
                                                обжарка: ${roastDegreeItem.VALUE}
                                            </div>`"
                                    >
                                    <svg v-if="roastDegreeItem.VALUE === 'эспрессо'" width="16" height="16">
                                        <use xlink:href="/sprite.svg#icon-roasting-1"></use>
                                    </svg>
                                    <svg width="16" height="16">
                                        <use xlink:href="/sprite.svg#icon-roasting-1"></use>
                                    </svg>
                                </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="product-card-footer coffee-card-controls__footer coffee-card__footer">
                    <div class="product-card-footer__prices">
                        <p class="product-card-footer__price-old" v-if="prices.old">
                            <span v-html="prices.old" /><span></span>
                        </p>
                        <p class="product-card-footer__price" >
                            <span v-html="prices.current" /><span></span>
                        </p>
                    </div>

                    <div class="product-card-footer__quantity coffee-card__quantity">
                        <quantity-input
                            v-model.number="quantity"
                            :in-cart="!!productInCart"
                            @focus="toggleCardActive(true)"
                            @blur="quantityBlurHandler"
                        />
                    </div>
                    <div class="product-card-footer__to-cart">
                        <to-cart-btn
                            class="coffee-card__to-cart"
                            :is-loading="isLoading"
                            :in-cart="!!productInCart"
                            @click.prevent="toCartClickHandler"
                        ></to-cart-btn>
                        <div class="product-card-footer__hint" v-if="!productInCart && showBuyHint && isHintsActive">
                            <a class="product-card-footer__hint-close" @click="hideHint('BX_ONBOARDING_BUY_CLOSE')">
                                <svg width="16" height="16"><use xlink:href="/sprite.svg#icon-close-nofill"></use></svg>
                            </a>
                            <div class="product-card-footer__hint-text">Выберите способ приготовления</div>
                        </div>
                    </div>
                </div>

                <!-- <transition name="grinding-list">
                    <div class="coffee-card-controls__grinding" v-if="showGrinding">
                        <div class="grinding-list">
                            <ul class="grinding-list__body">
                                <li
                                    class="grinding-list__item"
                                    v-for="item in grindingItems"
                                    :key="item.ID"
                                >
                                    <a
                                        class="grinding-list__link grinding-item grinding-item--product-popup"
                                        @click.prevent="selectGrinding(item)"
                                    >
                                        <svg>
                                            <use  v-bind="{'xlink:href': `/sprite.svg#icon-grinding-${item.XML_ID}`}"></use>
                                        </svg>
                                        <span>{{ item.VALUE }}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </transition> -->
            </div>
        </transition>
    </form>
</template>

<script>
import Cookies from 'js-cookie';
import { EVENT_ADD_TO_CART } from '../../services/event-bus/event-types';
import { DEFAULT_GRINDING_ICON_PATH, ICONS_PATH } from '../../constants';
import { globalErrorHandler } from '../../services/error-handling';

const { eventBus } = window.specialtyApp;

export default {
    name: 'coffee-card-controls',

    inject: ['$basketService'],

    data() {
        return {
            isLoading: false,
            oldQuantity: 1,
            productChangeProcess: false,
            quantity: 1,
            selectedWeight: null,
            selectedRoast: null,
            // showGrinding: false,
            selectedGrinding: null,
            DEFAULT_GRINDING_ICON_PATH,
            ICONS_PATH,

            selectedQuantity: null,
        };
    },

    props: {
        roaster: {
            type: String,
            required: false
        },
        actualItem: {
            type: Object,
            required: true,
        },

        grindingItems: {
            type: [Array, String],
            required: false,
        },

        deliveryPeriods: {
            type: Object,
        },

        hintsActive: {
            type: String,
        },
    },

    methods: {
        async addToBasket() {
            this.isLoading = true;

            let props = {};

            if (this.selectedGrinding?.VALUE) {
                props = {
                    pomol: {
                        name: 'Помол',
                        value: this.selectedGrinding.VALUE,
                    }
                };
            }
            if (this.roaster) {
                props.roaster = {
                    name: 'Обжарщик',
                    value: this.roaster
                }
            }


            try {
                const { data: { data } } = await this.$basketService.addToBasket(
                    this.currentOffer?.ID || this.actualItem.ID,
                    this.quantity,
                    props,
                );
                eventBus.$emit(EVENT_ADD_TO_CART, {
                    basketData: data,
                    quantity: this.quantity,
                    type: 'coffee',
                    actualItem: this.actualItem,
                    offer: this.currentOffer,
                    grinding: this.selectedGrinding,
                    deliveryPeriods: this.deliveryPeriods,
                });
            } catch (error) {
                globalErrorHandler(error);
            } finally {
                this.isLoading = false;
            }
        },

        addSuccessHandler({ basketData, quantity }) {
            eventBus.$emit(EVENT_ADD_TO_CART, {
                type: 'coffee',
                offer: this.currentOffer,
                actualItem: this.actualItem,
                basketData,
                quantity,
            });
        },

        // closeGrindingList() {
        //     this.showGrinding = false;
        // },

        async deleteFromBasket() {
            this.isLoading = true;

            try {
                await this.$basketService.deleteFromBasket(this.productInCart.ID);
                await this.$nextTick();

                this.quantity = 1;
            } catch (error) {
                globalErrorHandler(error);
            } finally {
                this.isLoading = false;
            }
        },

        // openGrindingList() {
        //     this.showGrinding = true;
        // },

        quantityBlurHandler() {
            if (this.quantity === '') {
                this.quantity = this.oldQuantity;
            }

            this.toggleCardActive(false);
        },

        quantityWatchHandler(newQuantity, oldQuantity) {
            if (newQuantity === '') {
                this.oldQuantity = oldQuantity;
                return;
            }

            if (
                newQuantity === oldQuantity
                || !this.productInCart
                || this.productChangeProcess
            ) {
                return;
            }

            this.updateQuantityHandler();
        },

        selectGrinding(grindingItem) {
            this.selectedGrinding = grindingItem || null;
            // this.closeGrindingList();
        },

        toggleCardActive(flag) {
            const $infoElement = $(this.$el)
                .closest('.coffee-card');
            const method = flag ? 'addClass' : 'removeClass';

            $infoElement[method]('coffee-card--active');
        },

        toCartClickHandler() {
            // Если это не набор/капсула или еще какой-то товар без помола, то надо установить дефолтный помол
            if (!this.disableGrinding) this.selectGrinding(this.defaultGrinding);

            this.addToBasket();
        },

        async updateInBasket() {
            this.isLoading = true;

            try {
                await this.$basketService.updateInBasket(this.productInCart.ID, this.quantity);
            } catch (error) {
                globalErrorHandler(error);
            } finally {
                this.isLoading = false;
            }
        },

        updateQuantityHandler: BX.debounce(function handler() {
            if (this.quantity <= 0) {
                this.deleteFromBasket();
                return;
            }

            this.updateInBasket();
        }, 500),

        /**
         * Порверяет в url наличие сортировки,
         * сортирует офферы внутри карточки кофе по возрастанию цены
         * и делает активным тот оффер, у которого наименьшая цена
         */
        getMinPriceOffer() {
            // Смотрим, что там по сортировке в URL
            // (sort-by=price - по возрастанию, sort-by=price&sort-order=desc -- по убыванию)
            const { searchParams } = new URL(window.location);

            try {
                searchParams.forEach((value, key) => {
                    if (key === 'sort-by' && value === 'price') {
                        const offers = Object.values(this.actualItem?.OFFERS);

                        offers.sort((a, b) => {
                            const af = a.PROPERTIES?.STEPEN_OBZHARKI?.VALUE === 'фильтр' ? -1 : 1;
                            const bf = b.PROPERTIES?.STEPEN_OBZHARKI?.VALUE === 'фильтр' ? -1 : 1;
                            return a.CURRENT_PRICE?.DISCOUNT_VALUE - b.CURRENT_PRICE?.DISCOUNT_VALUE || af - bf;
                        });

                        const currentOffer = offers[0];
                        this.selectedWeight = currentOffer?.PROPERTIES?.VES_UPAKOVKI?.VALUE.replace(/\s/g, '');
                        this.selectedRoast = currentOffer?.PROPERTIES.STEPEN_OBZHARKI.VALUE;
                    }
                });
            } catch (error) {
                console.error(error.message);
            }
        },

        getActiveOffer(value) {
            if (value) {
                const offers = Object.values(this.actualItem?.OFFERS);

                const activeOffer = offers.find((offer) => +offer.ID === +value);
                this.selectedWeight = activeOffer?.PROPERTIES?.VES_UPAKOVKI?.VALUE.replace(/\s/g, '');
                this.selectedRoast = activeOffer?.PROPERTIES.STEPEN_OBZHARKI.VALUE;
            }
        },

        hideHint(val) {
            if (!Cookies.get(val)) {
                Cookies.set(val, 'Y');
            }

            $('.product-card-footer__hint').remove();
        },
    },

    computed: {
        initActiveOfferId() {
            return this.actualItem.ACTIVE_OFFER_ID;
        },

        activeOfferId() {
            return this.currentOffer ? this.currentOffer.ID : null;
        },

        isHintsActive() {
            if (this.hintsActive === 'Y') {
                return true;
            }

            return false;
        },

        disableGrinding() {
            const {
                SECTION_ID_COFFEE_CAPSUL,
                SECTION_ID_COFFEE_COMPLECT,
                SECTION_ID_COFFEE_DRIP,
            } = window.specialtyApp.settings;

            return [SECTION_ID_COFFEE_CAPSUL, SECTION_ID_COFFEE_COMPLECT, SECTION_ID_COFFEE_DRIP]
                .some((id) => id === this.actualItem.IBLOCK_SECTION_ID);
        },

        availableOffersByRoast() {
            const result = this.actualItem?.FILTERS?.ROAST_DEGREE;

            return result[this.selectedRoast]?.OFFERS;
        },

        basketRows() {
            return Object.values(this.$basketService.state.basketData.BASKET.ITEMS);
        },

        currentOffer() {
            if (this.actualItem.FILTERS?.QUANTITY_PACK) {
                return Object.values(this.actualItem.OFFERS)
                    .find((offer) => {
                        const quantityValue = offer?.PROPERTIES?.SHTUK_V_UPAKOVKE?.VALUE.replace(/\s/g, '');

                        return quantityValue === this.selectedQuantity;
                    });
            }

            return Object.values(this.actualItem?.OFFERS || {})
                .find((offer) => {
                    const normalWeightValue = offer?.PROPERTIES?.VES_UPAKOVKI?.VALUE.replace(/\s/g, '');
                    const roastValue = offer?.PROPERTIES?.STEPEN_OBZHARKI?.VALUE;

                    return normalWeightValue === this.selectedWeight
                        && roastValue === this.selectedRoast;
                });
        },

        productInCart() {
            return this.basketRows.find((basketItem) => `${basketItem.PRODUCT_ID}` === `${this.currentOffer?.ID || this.actualItem.ID}`);
        },

        prices() {
            const price = this.currentOffer?.CURRENT_PRICE || this.actualItem?.CURRENT_PRICE;

            return {
                current: price?.PRINT_DISCOUNT_VALUE,
                old: price?.PRINT_VALUE !== price?.PRINT_DISCOUNT_VALUE ? price?.PRINT_VALUE : null,
            };
        },

        roastDegreeItems() {
            try {
                return Object.values(this.actualItem?.FILTERS?.ROAST_DEGREE || {})
                    .sort(({ VALUE }) => (VALUE === 'фильтр' ? -1 : 1));
            } catch (error) {
                return [];
            }
        },

        weightItems() {
            return Object.values(this.actualItem?.FILTERS?.WEIGHT || {})
                .filter((item) => Object.values(this.actualItem.OFFERS)
                    .find((offer) => {
                        const normalWeightValue = offer?.PROPERTIES?.VES_UPAKOVKI?.VALUE.replace(/\s/g, '');
                        const roastValue = offer?.PROPERTIES?.STEPEN_OBZHARKI?.VALUE;

                        return normalWeightValue === `${item.VALUE}`
                                && roastValue === this.selectedRoast;
                    }));
        },

        quantityItems() {
            return Object.values(this.actualItem.FILTERS?.QUANTITY_PACK || {})
                .filter((item) => Object.values(this.actualItem.OFFERS)
                    .find((offer) => {
                        const normalQuantityValue = offer?.PROPERTIES?.SHTUK_V_UPAKOVKE?.VALUE.replace(/\s/g, '');

                        return normalQuantityValue === `${item.VALUE}`;
                    }));
        },

        defaultGrinding() {
            const index = this.grindingItems.findIndex((item) => item.VALUE === 'В зёрнах (не молоть)');
            return this.grindingItems[index !== -1 ? index : 0];
        },

        showBuyHint() {
            if (!Cookies.get('BX_ONBOARDING_HELP') && !Cookies.get('BX_ONBOARDING_CATALOG') && !Cookies.get('BX_ONBOARDING_BUY_CLOSE')) {
                return true;
            }

            return false;
        },
    },

    watch: {
        initActiveOfferId: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.getActiveOffer(newValue);
                }
            },
        },

        activeOfferId: {
            immediate: true,
            handler(id) {
                // По-другому не дотянуться до корневого элемента...
                // coffee-card__image
                // coffee-card__title
                const linkImage = this.$root.$el.querySelector('.coffee-card__image');
                const linkTitle = this.$root.$el.querySelector('.coffee-card__title');

                const links = [linkImage, linkTitle];

                links.forEach((link) => {
                    const url = new URL(link.href);
                    url.searchParams.set('offer', id);

                    // eslint-disable-next-line no-param-reassign
                    link.href = url;
                });
            },
        },

        productInCart: {
            immediate: true,
            deep: true,
            handler(newProduct) {
                this.productChangeProcess = true;

                if (newProduct) {
                    this.quantity = newProduct.QUANTITY;
                } else {
                    this.quantity = 1;
                }

                this.$nextTick(() => {
                    this.productChangeProcess = false;
                });
            },
        },

        quantity: 'quantityWatchHandler',

        roastDegreeItems: {
            immediate: true,
            handler(newValue) {
                if (!newValue || !newValue.length) {
                    return;
                }

                this.selectedRoast = this.selectedRoast || newValue[0].VALUE;
            },
        },

        // showGrinding(flag) {
        //     const $infoElement = $(this.$el)
        //         .closest('.coffee-card__info');
        //     const method = flag ? 'addClass' : 'removeClass';

        //     $infoElement[method]('coffee-card__info--no-shadow');
        // },

        weightItems: {
            immediate: true,
            handler(newValue) {
                if (!newValue || !newValue.length) {
                    return;
                }

                const availableWeight = newValue.find((el) => el.VALUE === this.selectedWeight);
                this.selectedWeight = availableWeight ? availableWeight.VALUE : newValue[0].VALUE;
            },
        },

        quantityItems: {
            immediate: true,
            handler(newValue) {
                if (!newValue || !newValue.length) {
                    return;
                }

                this.selectedQuantity = this.selectedQuantity || newValue[0].VALUE;
            },
        },
    },
};
</script>
